<div class="protocol-list-container" [style.height]="categoryDescription ? 'calc(100% - 55px)' : '100%'">
  <abc-tree
    #categoryListTree
    [data]="categoryList"
    [selectByClick]="true"
    [focusStateEnabled]="false"
    [selectionMode]="'single'"
    displayExpr="caption"
    hasItemsExpr="children"
  ></abc-tree>

  @if (categoryDescription) {
    <p class="description-container">
      {{ categoryDescription }}
    </p>
  }
</div>
